<template>
	<div v-on="$listeners" class="surf-inline-two-text-style2 surf-transition-hover-lift">
		<div class="content">
			<div class="date">{{ normalizeYMDFormat(formattedItem.date) }}</div>
			<div class="value-section">
				<div class="value text-overflow">{{ formattedItem.value }}</div>
				<div class="sub-value">{{ formattedItem.value2 }}</div>
			</div>
		</div>
		<div class="icon">
			<SvgIcons name="surf_frame" class="frame-icon" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { normalizeYMDFormat } from '@/utils/format';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});
</script>

<style lang="less" scoped>
.surf-inline-two-text-style2 {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	padding: 10px 16px;
	border-radius: 8px;
	background-color: var(--surf-secondary-color);
	cursor: pointer;

	.content {
		flex: 1;
		width: 0;
		display: flex;

		.date {
			width: 95px;
			color: rgba(var(--surf-inverse-color-rgb), 0.6);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px;
		}

		.value-section {
			flex: 1;
			width: 0;
			display: flex;
			flex-direction: column;

			.value {
				color: var(--surf-inverse-color);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}

			.sub-value {
				margin-top: 8px;
				color: rgba(var(--surf-inverse-color-rgb), 0.4);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}
		}
	}

	.icon {
		display: flex;
		align-items: center;
		justify-content: center;

		.frame-icon {
			font-size: 32px;
			color: var(--surf-inverse-color) !important;
		}
	}
}
</style>
